import LandingPage from './LandingPage';

// V1 — the original landing page. Content lives in LandingPage's DEFAULT_CONTENT.
const ColdTrafficLP1 = () => <LandingPage variantName="V1" />;

export default ColdTrafficLP1;
